import {html} from "../libs/lit.dist.js";
import {WebElement} from "./abstract-element.js";

const PARENT = Symbol();

export class PkTextCounter extends WebElement {

    static get properties() {
        return {
            parent: {type: HTMLElement},
            for: {type: String},
            max: {type: Number},
            warning: {type: Number},
            format: {type: String},
        };
    }

    /**
     * @inheritDoc
     */
    constructor() {
        super();
        this.parent = null;
        this.for = '';
        this.max = -1;
        this.warning = 90;
        this.format = "({current} / {max} znaków)";
        this.onParentChange = () => {
            this.requestUpdate();
        };
    }

    get parent() {
        return this[PARENT];
    }

    set parent(parent) {
        if (typeof parent === 'string') {
            this.for = parent;
            parent = document.getElementById(parent);
        } else {
            this.for = '';
        }

        if (parent instanceof jQuery) {
            parent = parent[0];
        }

        if (this[PARENT] && this[PARENT] !== parent) {
            this[PARENT].removeEventListener('input', this.onParentChange);
        }
        this[PARENT] = parent;
        if (this[PARENT]) {
            this[PARENT].addEventListener('input', this.onParentChange);
        }
    }

    firstUpdated() {
        if (!this[PARENT] && this.for) {
            this.parent = this.for;
        }
    }

    getMaxValue() {
        if (this.max >= 0) {
            return this.max;
        }
        if (this.parent) {
            return Number(this.parent.maxLength);
        }
        return 0;
    }

    getCurrentValue() {
        if (this.parent) {
            return String(this.parent.value).length;
        }
        return 0;
    }

    #formatLabel(values) {
        let value = this.format;
        for (let key in values) {
            value = value.replace(`{${key}}`, String(values[key]));
        }
        return value;
    }

    /**
     * @inheritDoc
     * @returns {v}
     */
    render() {
        const currentValue = this.getCurrentValue();
        const maxValue = this.getMaxValue();
        let percent = 0;
        if (maxValue > 0) {
            percent = currentValue / maxValue * 100;
        }
        const cssClasses = [];
        if (percent >= 100) {
            cssClasses.push('text-danger')
        } else if (percent >= this.warning) {
            cssClasses.push('text-warning')
        }

        const value = this.#formatLabel({
            current: currentValue,
            max: maxValue,
            left: Math.max(0, maxValue - currentValue),
            percent: Math.round(percent),
            percentLeft: Math.round(100 - percent),
        });
        return html`
            <span class="${cssClasses.join(' ')}">${value}</span>
        `;
    }
}

customElements.define('pk-text-counter', PkTextCounter);
